import React from "react";
import { Chip } from "@mui/material";

export function money(value, currency = "ARS") {
  try {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency,
      maximumFractionDigits: currency === "ARS" ? 0 : 2,
    }).format(Number(value || 0));
  } catch {
    return `${currency} ${Number(value || 0).toLocaleString("es-AR")}`;
  }
}

const SALE_LABELS = {
  draft: "Borrador",
  quoted: "Cotizada",
  accepted: "Aceptada",
  in_progress: "En curso",
  completed: "Completada",
  cancelled: "Cancelada",
};

const PAYMENT_LABELS = {
  pending: "Pendiente",
  partial: "Parcial",
  paid: "Cobrada",
};

export function SaleStatusChip({ status }) {
  return <Chip size="small" variant="outlined" label={SALE_LABELS[status] || status} />;
}

export function PaymentStatusChip({ status }) {
  return (
    <Chip
      size="small"
      label={PAYMENT_LABELS[status] || status}
      color={status === "paid" ? "success" : status === "partial" ? "warning" : "default"}
      variant={status === "pending" ? "outlined" : "filled"}
    />
  );
}

export const SALE_STATUS_OPTIONS = Object.entries(SALE_LABELS);
